import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShaderEffect: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconShaderEffect"><Path d="M21 21H3.06055L21 3.06055V21Z" fill="currentColor"/><Path d="M3 18.9395V13.0605L13.0605 3H18.9395L3 18.9395Z" fill="currentColor"/><Path d="M3 10.9395V3H10.9395L3 10.9395Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShaderEffect;
